'use client';

import { __spreadArray } from '../../_virtual/_tslib.js';
import React__default from 'react';
import Skeleton from '../../Skeleton/index.js';
import { Container, Slide } from './Slides.css.js';

var Slides = function (props) {
    var innerRef = props.innerRef, spaceBetween = props.spaceBetween, elementPerView = props.elementPerView, widthElement = props.widthElement, children = props.children, loading = props.loading, _a = props.loadingHeight, loadingHeight = _a === void 0 ? 250 : _a;
    var renderLoading = function () {
        return (React__default.createElement(Container, null, __spreadArray([], Array(elementPerView), true).map(function (_, idx) { return (React__default.createElement(Slide, { widthElement: widthElement, key: idx, spaceElement: spaceBetween },
            React__default.createElement(Skeleton, { height: loadingHeight, width: widthElement }))); })));
    };
    var renderSlides = function () {
        return (React__default.createElement(Container, { ref: innerRef }, Array.isArray(children) ? (Object.values(children).map(function (item, idx) { return (React__default.createElement(Slide, { widthElement: widthElement, key: idx, spaceElement: spaceBetween }, item)); })) : (React__default.createElement(Slide, { widthElement: widthElement }, children))));
    };
    return loading ? renderLoading() : renderSlides();
};

export { Slides as default };
//# sourceMappingURL=index.js.map
